/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Research_Document_CrumbInputs */

const en_research_document_crumb = /** @type {(inputs: Research_Document_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

/**
* | output |
* | --- |
* | "Document" |
*
* @param {Research_Document_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const research_document_crumb = /** @type {((inputs?: Research_Document_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Research_Document_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_research_document_crumb(inputs)
});